import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import LatestUpdates from './components/LatestUpdates';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/home';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'http://ekaichem.com/#organization',
      'name': '韩漫吧',
      'alternateName': 'HanManBa',
      'url': 'http://ekaichem.com/',
      'description': siteInfo.description,
      'foundingDate': '2021',
      'logo': {
        '@type': 'ImageObject',
        'url': 'http://ekaichem.com/logo.png',
      },
      'sameAs': [
        'http://ekaichem.com/',
        'http://ekaichem.com/',
      ],
    },
    {
      '@type': 'WebSite',
      '@id': 'http://ekaichem.com/#website',
      'url': 'http://ekaichem.com/',
      'name': '韩漫吧',
      'description': siteInfo.description,
      'inLanguage': 'zh-CN',
      'publisher': { '@id': 'http://ekaichem.com/#organization' },
    },
    {
      '@type': 'WebPage',
      '@id': 'http://ekaichem.com/#webpage',
      'url': 'http://ekaichem.com/',
      'name': '韩漫吧 - 免费漫画大全 - 下拉式韩漫在线阅读',
      'description': siteInfo.description,
      'inLanguage': 'zh-CN',
      'isPartOf': { '@id': 'http://ekaichem.com/#website' },
      'about': { '@id': 'http://ekaichem.com/#organization' },
      'primaryImageOfPage': {
        '@type': 'ImageObject',
        'url': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20epic%20fantasy%20landscape%20with%20warm%20sunset%20golden%20lighting&width=1800&height=1000&seq=hero-bg-main&orientation=landscape',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
        />
        <HeroSection />
        <FeaturedSection />
        <LatestUpdates />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}